import React from "react";
import { fileUrl } from "../lib/api";

const isVideo = (path) => /\.(mp4|mov|webm)(\?|$)/i.test(path || "");

/**
 * Renders an image or a video depending on the storage path extension.
 * - Disables right-click and dragging (anti-download).
 * - For videos: muted, loop, playsInline, controls toggleable via prop.
 */
const Media = ({ path, className = "", controls = false, autoPlay = true, watermark = false, alt = "" }) => {
  if (!path) return null;
  const url = fileUrl(path);
  if (isVideo(path)) {
    return (
      <div className={`relative ${className}`} onContextMenu={(e) => e.preventDefault()}>
        <video
          src={url}
          className="w-full h-full object-cover no-save"
          autoPlay={autoPlay}
          muted
          loop
          playsInline
          controls={controls}
          controlsList="nodownload noplaybackrate"
          disablePictureInPicture
          onContextMenu={(e) => e.preventDefault()}
        />
        {watermark && <div className="cherub-watermark absolute inset-0 pointer-events-none" />}
      </div>
    );
  }
  return (
    <div className={`relative ${className}`} onContextMenu={(e) => e.preventDefault()}>
      <img
        src={url}
        alt={alt}
        className="w-full h-full object-cover no-save"
        draggable={false}
        onContextMenu={(e) => e.preventDefault()}
      />
      {watermark && <div className="cherub-watermark absolute inset-0 pointer-events-none" />}
    </div>
  );
};

export { isVideo };
export default Media;
